import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "@/views/Dashboard.vue";
import Tables from "@/views/Tables.vue";
import Billing from "@/views/Billing.vue";
import VirtualReality from "@/views/VirtualReality.vue";
import Profile from "@/views/Profile.vue";
import Rtl from "@/views/Rtl.vue";
import SignIn from "@/views/SignIn.vue";
import SignUp from "@/views/SignUp.vue";
import UserRegister from "@/views/UserRegister.vue";
import Questions from "@/views/Questions.vue";
import Office from "@/views/Office.vue";
import Material from "@/views/Material.vue";
import MaterialType from "@/views/MaterialType.vue";
import Vehicle from "@/views/Vehicle.vue";
import Events from "@/views/Events.vue";
import SurveyQuestions from "@/views/SurveyQuestions.vue";
import Media from "@/views/Media.vue";
import MediaHistory from "@/views/MediaHistory.vue";
import MediaDetailsPage from "@/views/MediaDetailsPage.vue";
import Religions from "@/views/Religion.vue";
import ReligionCategory from "@/views/ReligionCategory.vue";
import Candidates from "@/views/Candidates.vue";
import Users from "@/views/Users.vue";
import Task from "@/views/Task.vue";
import AddEvent from "@/views/AddEvent.vue";
import EditEvent from "@/views/EditEvent.vue";
import AddVehicle from "@/views/AddVehicle.vue";
import EditCandidate from "@/views/EditCandidate.vue";
import EditUser from "@/views/EditUser.vue";
import EditTask from "@/views/EditTask.vue";
import RequestVehicle from "@/views/RequestVehicle.vue";
import Team from "@/views/Team.vue";
import Area from "@/views/Area.vue";
import Stock from "@/views/Stock.vue";
import AreaEdit from "@/views/AreaEdit.vue";
import AddVotersGroup from "@/views/AddVotersGroup.vue";
import EditVotersGroup from "@/views/EditVotersGroup.vue";
import EditOffice from "@/views/EditOffice.vue";
import EditSurvey from "@/views/EditSurvey.vue";
import stockRequest from "@/views/stockRequest.vue";
import Categories from "@/views/Categories.vue";
import SocialMediaPostAdd from "@/views/SocialMediaPostAdd.vue";
import SocialMediaPost from "@/views/SocialMediaPost.vue";
import Roles from "@/views/Roles.vue";
import DeviceGroup from "@/views/DeviceGroup.vue";
import UserGroup from "@/views/UserGroup.vue";
import PlayList from "@/views/PlayList.vue";
import AddPlaylist from "@/views/AddPlaylist.vue";
import EditPlaylist from "@/views/components/EditPlaylist.vue";
import MediaGallery from "@/views/components/MediaGallery.vue";
import EditMediaGallery from "@/views/components/EditMediaGallery.vue";
import Content from "@/views/components/Content.vue";
import Devices from "@/views/components/Devices.vue";
import Branches from "@/views/components/Branches.vue";
import DeletedContent from "@/views/components/DeletedContent.vue";
import EmergencyBroadcast from "@/views/components/EmergencyBroadcast.vue";
import DevicePosition from "@/views/components/DevicePosition.vue";
import Tokens from "@/views/components/Tokens.vue";
import Counter from "@/views/components/Counter.vue";
import UserManagement from "@/views/UserManagement.vue";
import Services from "@/views/components/Services.vue"; // ADDED
import LiveVideos from "@/views/components/LiveVideos.vue";
import ActivePlaybackPlayer from "@/views/components/ActivePlaybackPlayer.vue";

import LiveWebhook from "@/views/components/LiveWebhook.vue";

import InstallationType from "@/views/components/InstallationType.vue";
import MedicalDashboard from "@/views/MedicalDashboard.vue";
import DoctorDashboard from "@/views/DoctorDashboard.vue";
import MedicalSignIn from "@/views/MedicalSignIn.vue";
import Tenants from "@/views/Tenants.vue";
import { hasPermission } from "@/utils/permissions";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },

  {
    path: "/medical-sign-in",
    name: "Medical Sign In",
    component: MedicalSignIn,
  },

  {
    path: "/medical-dashboard",
    name: "Medical Dashboard",
    component: MedicalDashboard,
  },

  {
    path: "/doctor-dashboard",
    name: "Doctor Dashboard",
    component: DoctorDashboard,
  },

  {
    path: "/live-webhook",
    name: "Live Webhook",
    component: LiveWebhook,
  },


  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: "/user-management",
    name: "User Management",
    component: UserManagement,
  },
  {
    path: "/content",
    name: "Content",
    component: Content,
    meta: { requiresAuth: true }
  },
  {
    path: "/live-videos",
    name: "Live Videos",
    component: LiveVideos,
    meta: { requiresAuth: true }
  },
  {
    path: "/deleted-content",
    name: "DeletedContent",
    component: DeletedContent,
    meta: { requiresAuth: true }
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
  },
  {
    path: "/user-register",
    name: "User Register",
    component: UserRegister,
  },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { requiresAuth: true }
  },
  {
    path: "/device-group",
    name: "Device Group",
    component: DeviceGroup,
    meta: { requiresAuth: true }
  },
  {
    path: "/user-group",
    name: "User Group",
    component: UserGroup,
    meta: { requiresAuth: true }
  },
  {
    path: "/playlist",
    name: "Play List",
    component: PlayList,
    meta: { requiresAuth: true }
  },
  {
    path: "/branches",
    name: "Branches",
    component: Branches,
    meta: { requiresAuth: true }
  },
  {
    path: "/devices",
    name: "Devices",
    component: Devices,
    meta: { requiresAuth: true }
  },
  {
    path: "/add-playlist",
    name: "Add Playlist",
    component: AddPlaylist,
    meta: { requiresAuth: true }
  },
  {
    path: "/edit-playlist/:id",
    name: "Edit Playlist",
    component: EditPlaylist,
    meta: { requiresAuth: true }
  },
  {
    path: "/emergency-broadcast",
    name: "Emergency Broadcast",
    component: EmergencyBroadcast,
    meta: { requiresAuth: true }
  },
  {
    path: "/device-position",
    name: "Device Position",
    component: DevicePosition,
    meta: { requiresAuth: true }
  },
  {
    path: "/tokens",
    name: "Tokens",
    component: Tokens,
    meta: { requiresAuth: true }
  },
  {
    path: "/counter",
    name: "Counter",
    component: Counter,
    meta: { requiresAuth: true }
  },
  {
    path: "/installation-type",
    name: "Installation Type",
    component: InstallationType,
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  },
  {
    path: "/player/:device_id?",
    name: "Active Playback Player",
    component: ActivePlaybackPlayer,
    meta: { requiresAuth: false } // Set false so display devices can run without login session
  },
  {
    path: "/services",
    name: "Services & Prefix",
    component: Services,
    meta: { requiresAuth: true }
  },
  {
    path: "/media-gallery",
    name: "Media Gallery",
    component: MediaGallery
  },
  {
    path: "/edit-media-gallery",
    name: "Edit Media Gallery",
    component: EditMediaGallery
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
    meta: { requiresAuth: true }
  },
  {
    path: "/candidates",
    name: "Candidates",
    component: Candidates,
    meta: { requiresAuth: true }
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { requiresAuth: true }
  },
  {
    path: '/marquee-broadcast',
    name: 'MarqueeBroadcast',
    component: () => import('../views/MarqueeBroadcast.vue')
  },
  {
    path: "/questions",
    name: "Questions",
    component: Questions,
    meta: { requiresAuth: true }
  },
  {
    path: "/category",
    name: "Categories",
    component: Categories,
    meta: { requiresAuth: true }
  },
  {
    path: "/office",
    name: "Office",
    component: Office,
    meta: { requiresAuth: true }
  },
  {
    path: "/resources",
    name: "Material",
    component: Material,
    meta: { requiresAuth: true }
  },
  {
    path: "/resources-type",
    name: "MaterialType",
    component: MaterialType,
    meta: { requiresAuth: true }
  },
  {
    path: "/vehicle",
    name: "Vehicle",
    component: Vehicle,
    meta: { requiresAuth: true }
  },
  {
    path: "/request_vehicle",
    name: "Request-Vehicle",
    component: RequestVehicle,
    meta: { requiresAuth: true }
  },
  {
    path: "/events",
    name: "Events",
    component: Events,
    meta: { requiresAuth: true }
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: { requiresAuth: true }
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
    meta: { requiresAuth: true }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: "/social-media-post",
    name: "Social Media Post",
    component: SocialMediaPost,
    meta: { requiresAuth: true }
  },
  {
    path: "/social-media-post-add",
    name: "Social Media Post Add",
    component: SocialMediaPostAdd,
    meta: { requiresAuth: true }
  },
  {
    path: "/rtl-page",
    name: "Rtl",
    component: Rtl,
    meta: { requiresAuth: true }
  },
  {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn
  },
  {
    path: "/edit-Survey/:id",
    name: "Edit Survey",
    component: EditSurvey,
    meta: { requiresAuth: true }
  },
  {
    path: "/edit-office/:id",
    name: "Edit office",
    component: EditOffice,
    meta: { requiresAuth: true }
  },
  {
    path: "/survey-questions/:id",
    name: "Survey Questions",
    component: SurveyQuestions,
    meta: { requiresAuth: true }
  },
  {
    path: "/media",
    name: "Media",
    component: Media,
    meta: { requiresAuth: true }
  },
  {
    path: "/media-history",
    name: "Media History",
    component: MediaHistory,
    meta: { requiresAuth: true }
  },
  {
    path: '/media-details/:userId',
    name: 'media-details',
    component: MediaDetailsPage,
    props: true,
  },
  {
    path: "/religion",
    name: "Religions",
    component: Religions,
    meta: { requiresAuth: true }
  },
  {
    path: "/religions-category",
    name: "ReligionCategory",
    component: ReligionCategory,
    meta: { requiresAuth: true }
  },
  {
    path: "/task",
    name: "Task",
    component: Task,
    meta: { requiresAuth: true }
  },
  {
    path: "/add-event",
    name: "Add Event",
    component: AddEvent,
    meta: { requiresAuth: true }
  },
  {
    path: "/edit-event/:id",
    name: "Edit Event",
    component: EditEvent,
    meta: { requiresAuth: true }
  },
  {
    path: "/add-vehicle",
    name: "Add Vehicle",
    component: AddVehicle,
    meta: { requiresAuth: true }
  },
  {
    path: "/stock-request",
    name: "Stock Request",
    component: stockRequest,
    meta: { requiresAuth: true }
  },
  {
    path: "/edit-candidate/:id",
    name: "Edit Candidate",
    component: EditCandidate,
    meta: { requiresAuth: true }
  },
  {
    path: "/edit-user/:id",
    name: "Edit User",
    component: EditUser,
    meta: { requiresAuth: true }
  },
  {
    path: "/edit-task/:id",
    name: "Edit Task",
    component: EditTask,
    meta: { requiresAuth: true }
  },
  {
    path: "/team",
    name: "Team",
    component: Team,
    meta: { requiresAuth: true }
  },
  {
    path: "/area",
    name: "Area",
    component: Area,
    meta: { requiresAuth: true }
  },
  {
    path: "/stock",
    name: "Stock",
    component: Stock,
    meta: { requiresAuth: true }
  },
  {
    path: "/edit-area/:id",
    name: "Area Edit",
    component: AreaEdit,
    meta: { requiresAuth: true }
  },
  {
    path: "/add-voters-group",
    name: "Add Voters Group",
    component: AddVotersGroup,
    meta: { requiresAuth: true }
  },
  {
    path: "/edit-voters-group/:id",
    name: "Edit Voters Group",
    component: EditVotersGroup,
    meta: { requiresAuth: true }
  },
  {
    path: "/tenants",
    name: "Tenants",
    component: Tenants,
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  },
];



const router = createRouter({
  // THIS IS THE KEY: Use the subfolder as the base
  history: createWebHistory('/'),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  // Check EVERY possible key used by your app
  const token = localStorage.getItem('token') ||
    localStorage.getItem('auth_token') ||
    localStorage.getItem('admin_token') ||
    localStorage.getItem('medical_authenticated');

  const userRole = (localStorage.getItem('userRole') || localStorage.getItem('role') || '').toLowerCase().trim();
  const isSuperAdminUser = ['superadmin', 'super admin', '1'].includes(userRole);
  const instType = String(localStorage.getItem('installationType') || localStorage.getItem('installation_type') || '').toLowerCase();
  const isMedicalAdmin = (userRole === 'admin' || isSuperAdminUser) && (instType.includes('medical') || instType === '1');

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      // If no token is found in ANY of those keys, redirect
      next('/sign-in');
    } else if (to.matched.some(record => record.meta.requiresSuperAdmin) && !isSuperAdminUser) {
      // Prevent non-superadmins from accessing superadmin pages directly
      next('/dashboard');
    } else if (!isSuperAdminUser && to.name && to.name !== 'Dashboard') {
      const routeModuleMap = {
        'Edit User': 'Users',
        'User Register': 'Users',
        'Add Playlist': 'Play List',
        'Edit Playlist': 'Play List',
        'Add Event': 'Events',
        'Edit Event': 'Events',
        'Add Vehicle': 'Vehicle',
        'Edit Candidate': 'Candidates',
        'Edit Task': 'Task',
        'Edit Survey': 'Survey',
        'Survey Questions': 'Survey',
        'Edit office': 'Office',
        'Area Edit': 'Area',
        'Add Voters Group': 'Voters Group',
        'Edit Voters Group': 'Voters Group',
        'Social Media Post Add': 'Social Media Post',
        'Media Gallery': 'Media',
        'Edit Media Gallery': 'Media',
        'media-details': 'Media History'
      };
      const checkModule = routeModuleMap[to.name] || to.name;
      if (!hasPermission(checkModule, 'read')) {
        next('/dashboard');
      } else {
        next();
      }
    } else if (userRole === 'doctor') {
      // Doctor role is restricted to medical core operations
      const doctorAllowedPaths = ['/medical-dashboard', '/dashboard', '/users', '/roles', '/tokens', '/counter', '/services'];
      if (!doctorAllowedPaths.includes(to.path)) {
        next('/medical-dashboard');
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    // Only redirect if actively logged in and trying to access root or sign-in without logging out
    if (token && (userRole === 'doctor' || isMedicalAdmin) && (to.path === '/' || to.path === '/sign-in')) {
      const targetDash = isMedicalAdmin || userRole === 'doctor' ? '/medical-dashboard' : '/dashboard';
      next(targetDash);
    } else {
      next();
    }
  }
});

export default router;